import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { Copy } from '@grubhubprod/gh-cookbook-react';
import { CookbookCheckboxWrapper } from 'src/components/CookbookCheckboxWrapper/CookbookCheckboxWrapper';
import { CustomLabelWithTooltip } from 'src/components/common/CustomLabelWithTooltip/CustomLabelWithTooltip';

export interface AllocationsProps {
  name: string;
  id: string;
}

export function Allocations({ name, id }: AllocationsProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <CookbookCheckboxWrapper
      control={control}
      id={id}
      name={name}
      label={
        <CustomLabelWithTooltip
          color="primaryText"
          labelText="Allocations"
          tooltipInfo={
            <Copy variant="body" color="invertedPrimaryText">
              Allocation permission allows:
              <ul>
                <li>
                  One user to place a single order for a group of fellow
                  employees and allocate from each employee's line of credit
                </li>
                <li>Allocation against multiple expense codes</li>
              </ul>
            </Copy>
          }
        />
      }
    />
  );
}
